import {StorageKey} from './Storage';

export function isAuthenticated() {
    if (localStorage.getItem(StorageKey.Authenticated) === 'true') {
        let expirationString = localStorage.getItem(StorageKey.TokenExpiration);
        if (expirationString) {
            let expiration: number = +expirationString;
            if (expiration > Date.now()) {
                return true;
            }
        }
    }
    return false;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/AuthUtil.tsx